import { selectors } from './selector'

export const InfoBar = (() => {
	const initTargets = () => {
		const filter = selectors.getFilter()
		if (!filter) {
			return
		}

		const targets = selectors.getTargets()
		for (let i = 0, { length } = targets; i < length; i++) {
			const target = targets[i]
			if (!target) {
				continue
			}

			initHideInfoBar(target, filter)
		}
	}

	const initHideInfoBar = (infoBar: HTMLElement, filterButton: HTMLElement) => {
		const mutationObserver = new MutationObserver((mutationsList) => {
			mutationsList.forEach((mutation) => {
				if (mutation.attributeName === 'class' && filterButton.classList.contains('is-active')) {
					infoBar.classList.add('hidden')
				} else if (mutation.attributeName === 'class') {
					infoBar.classList.remove('hidden')
				}
			})
		})
		mutationObserver.observe(filterButton, { attributes: true })
	}

	const init = () => {
		initTargets()
	}

	return {
		init,
	}
})()
